import React, { useState } from 'react'
import { getImages } from '../const'
import { Link, NavLink } from 'react-router-dom'
import ModalLayout from './ModalLayout'

const Header = () => {
    const [isMob, setisMob] = useState(false);

    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu, setOpenSubMenu] = useState(null)
    const handleSubMenu = (menuName) => {
        setOpenSubMenu(prev => (prev === menuName ? null : menuName));
    };
    const closeMenu = () => {
        setisMob(false);
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    return (
        <>
            <header className="header-wrap">
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="main-logo">
                            <Link to="/"><img src={getImages('ew-logo.svg')} alt="logo" /></Link>
                        </div>
                        <div className={`menu-block ${isMob ? 'active' : ''}`}>
                            <div className="main-menu">
                                <ul className="d-inline-flex align-items-center">
                                    <li>
                                        <NavLink to="/" onClick={closeMenu}>Perfect Match</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/dealer-analysis" onClick={closeMenu}>Dealer Analysis</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/price-mismatch" onClick={closeMenu}>Price Mismatch</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/deal-vault" onClick={closeMenu}>Deal Vault</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* {!isMob && */}
                            <div className="actions-block d-xl-block d-none">
                                <div className="d-inline-flex align-items-center">
                                    <Link to="/chat" className="position-relative icon-btn">
                                        <img src={getImages('icon-message.png')} alt="message" />
                                        {/* <span className="position-absolute start-100 translate-middle bg-danger rounded-circle">
                                    <span>0</span>
                                </span> */}
                                    </Link>
                                </div>
                                <div className="btn-group custom-dropdown ms-4">
                                    <button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src={getImages('icon-user.png')} alt="user" /> Welcome Gregg <span className="down-arrow"></span>
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li><button className="dropdown-item" type="button">Action</button></li>
                                        <li><button className="dropdown-item" type="button">Another action</button></li>
                                        <li><button className="dropdown-item" type="button">Something else here</button></li>
                                    </ul>
                                </div>
                            </div>
                        {/* } */}
                        {/* {!isMob &&
                            <> */}
                        <div className='d-xl-none'>
                            <div className={`overflow-bg ${isMob ? 'active' : ''
                                }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                            <div
                                className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            >
                                <div
                                    className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                        }`}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                        {/* </>
                        } */}
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header